var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.5C11.8701 6.50143 10.7869 6.95091 9.988 7.74985C9.18907 8.54878 8.73959 9.63196 8.73816 10.7618H10.9048C10.9048 9.60592 11.8452 8.66667 13 8.66667C14.1548 8.66667 15.0952 9.60592 15.0952 10.7618C15.0952 11.4097 14.5741 11.8798 13.7778 12.5233C13.5177 12.7271 13.2679 12.9437 13.0292 13.1723C11.9481 14.2523 11.9167 15.3996 11.9167 15.5274V16.25H14.0833L14.0822 15.5642C14.0833 15.5469 14.118 15.1461 14.56 14.7052C14.7225 14.5427 14.9272 14.3802 15.1396 14.209C15.9835 13.5254 17.2607 12.493 17.2607 10.7618C17.2599 9.63198 16.8107 8.54863 16.0119 7.7496C15.2131 6.95056 14.1298 6.50115 13 6.5ZM11.9167 17.3333H14.0833V19.5H11.9167V17.3333Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 2.16669C7.02646 2.16669 2.16663 7.02652 2.16663 13C2.16663 18.9735 7.02646 23.8334 13 23.8334C18.9735 23.8334 23.8333 18.9735 23.8333 13C23.8333 7.02652 18.9735 2.16669 13 2.16669ZM13 21.6667C8.22138 21.6667 4.33329 17.7786 4.33329 13C4.33329 8.22144 8.22138 4.33335 13 4.33335C17.7785 4.33335 21.6666 8.22144 21.6666 13C21.6666 17.7786 17.7785 21.6667 13 21.6667Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/helpIcon.f7884b068d69900aa868eed892079f47.svg";
export { ForwardRef as ReactComponent };